module.exports = __webpack_public_path__ + "static/media/supercharger-sml.6a3abd0c.svg";